export default {"src":"/_next/static/media/all-routes.c1a03007.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};